// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__dcZvx","spinning":"Spinner_spinning__D4N8Y"};